import { createAction } from 'redux-act'

const openDonateVoucherModal = createAction('donate vocuher - open modal')
const closeDonateVoucherModal = createAction('donate vocuher - close modal')

export default { openDonateVoucherModal, closeDonateVoucherModal }
